import { $elements } from "@common/helpers/elements";

const ACTIVE_CLASS = "active";
const ACTIVE_TYPES = ["carousel", "child"];

function init($views) {
	const $view = $views[0];
	const $links = $elements("campaign-link");
	const hash = window.location ? window.location.hash : null;
	const $window = $(window);
	const nav = {};
	let active;

	function activate($link, id) {
		$links.forEach(($item) => $item.classList.remove(ACTIVE_CLASS));
		$link.classList.add(ACTIVE_CLASS);
		active = id;
	}

	function navigate(id) {
		if (active !== id) {
			$window.trigger("campaignNavigation", [id]);
		}
	}

	$links.forEach(($link) => {
		const $anchor = $link.querySelector("a");
		const href = $anchor ? $anchor.getAttribute("href") : null;

		if (href) {
			nav[href] = $link;
		}

		$link.addEventListener("click", (event) => {
			event.preventDefault();
			navigate(href);
		});
	});

	if (hash && nav[hash]) {
		activate(nav[hash], hash);
	} else if ($links.length > 0) {
		activate($links[0]);
	}

	function navigation(_event, id, type) {
		if (nav[id]) {
			activate(nav[id], id);
		}

		if (ACTIVE_TYPES.includes(type)) {
			$view.classList.add(ACTIVE_CLASS);
		} else {
			$view.classList.remove(ACTIVE_CLASS);
		}
	}

	$window.on("campaignNavigation", navigation);

	$window.on("campaignNavigationMenu", navigation);
}

export default {
	view: "scrollingCampaignNavigation",
	init: init,
};
